/* eslint-disable max-len */
import React from 'react'

interface PasswordErrorMessageProps {
  message?: string
}

const PasswordErrorMessage: React.FC<PasswordErrorMessageProps> = ({
  message = 'Password does not meet requirements'
}) => {
  return (
    <div className="relative flex-shrink-0 flex items-center gap-2 flex-row">
      <div className="relative flex-shrink-0 w-4 h-4 flex flex-col items-start">
        <svg
          className="absolute flex-shrink-0 top-[1px] right-[1px] bottom-[2px] left-[1px] overflow-visible"
          width="14"
          height="13"
          viewBox="0 0 14 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.1735 1.00056C5.94315 -0.333518 7.86858 -0.333519 8.63824 1.00055L13.5411 9.49889C14.3104 10.8322 13.3481 12.4983 11.8088 12.4983H2.00298C0.463666 12.4983 -0.49862 10.8322 0.270611 9.49889L5.1735 1.00056ZM6.90601 4.49829C7.18215 4.49829 7.40601 4.72215 7.40601 4.99829V7.49829C7.40601 7.77443 7.18215 7.99829 6.90601 7.99829C6.62986 7.99829 6.40601 7.77443 6.40601 7.49829V4.99829C6.40601 4.72215 6.62986 4.49829 6.90601 4.49829ZM6.90601 9.99829C7.18215 9.99829 7.40601 9.77443 7.40601 9.49829C7.40601 9.22215 7.18215 8.99829 6.90601 8.99829C6.62986 8.99829 6.40601 9.22215 6.40601 9.49829C6.40601 9.77443 6.62986 9.99829 6.90601 9.99829Z"
            fill="#FFD6A8"
          />
        </svg>
      </div>
      <div className="relative flex-shrink-0 text-left text-[#FFD6A8] text-xs font-semibold font-Montserrat leading-5">
        {message}
      </div>
    </div>
  )
}

export default PasswordErrorMessage
